import { render, staticRenderFns } from "./PillarOverviewHelp.vue?vue&type=template&id=27c4e608&scoped=true&lang=html&"
import script from "./PillarOverviewHelp.vue?vue&type=script&lang=js&"
export * from "./PillarOverviewHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c4e608",
  null
  
)

export default component.exports